import React from 'react';

function Layout(props) {
  return (
    <React.Fragment>

      <header>
      
        <div className='logo'></div>
        <div className='title'>
          <h1>El popular juego de cartas</h1>
        </div>
      </header>

      <main>
        {props.children}
      </main>

      <footer>
        <div className='logo'></div>
      </footer>
    </React.Fragment>
  );
}
export default Layout;